import React from "react";
import PropTypes from "prop-types";
import { withTheme } from "shared/context/theme";
import { Container, Divider } from "shared/layout";
import Logo from "shared/components/Logo";
import Search from "./Search";
import navigation from "./navigation";
import styles from "./styles.css";
import themes from "./themes";

const GlobalHeader = ({ theme }) => (
  <header className={theme.styles.header} role="banner">
    <Container className={theme.styles.container}>
      <Logo className={theme.styles.logo} />
      <Search className={theme.styles.search} />
      <navigation.Mobile className={theme.styles.navigationMobile} />
      <navigation.Desktop className={theme.styles.navigationDesktop} />
    </Container>
    {theme.name !== "blue" && (
      <Divider className={theme.styles.divider} container />
    )}
  </header>
);

GlobalHeader.propTypes = {
  theme: PropTypes.shape({
    name: PropTypes.string.isRequired,
    styles: PropTypes.shape({}).isRequired,
  }).isRequired,
};

export default withTheme(GlobalHeader, styles, themes);
